export const RUN_CAMPEON_MICROTEXT_BANK = {
  positivePickup: [
    "ENERGIA TOMADA",
    "AURA ARRIBA",
    "EL NORTE RESPONDE",
    "LA RUTA SE ABRE",
    "SIGUE ENTERO",
    "TU INSTINTO MANDA",
    "LA MARCA BRILLA",
    "EL LOBO AVANZA",
    "SUBE LIMPIO",
    "LA LUZ TE SIGUE",
    "EL BOSQUE CEDE",
    "TU HUELLA MANDA"
  ],

  strongPickup: [
    "ENERGIA CAMPEON",
    "AURA COMPLETA",
    "EL NORTE TE RECLAMA",
    "NADIE FRENA AL LOBO",
    "LA MANADA TE ESCUCHA",
    "TU NOMBRE SUBE",
    "TOMA EL CAMINO",
    "EL CUERPO DESPIERTA",
    "ERES ENERGIA",
    "LA MARCA TE ELIGE"
  ],

  comboPickup: [
    "CADENA LIMPIA",
    "OTRO GOLPE MAS",
    "NO SUELTES",
    "MAS CERCA",
    "MAS ALTO",
    "LA RUTA RESPONDE",
    "EL LOBO ACELERA",
    "ENERGIA EN LINEA"
  ],

  boostStart: [
    "AHORA CORRE",
    "MAS RAPIDO",
    "EL NORTE DELANTE",
    "PISA FUERTE",
    "SIN MIRAR ATRAS",
    "AURA ABIERTA",
    "SUBE SIN DUDA",
    "LLEGA"
  ],

  finalStretch: [
    "LA MANADA ESPERA",
    "CASA ESTA ARRIBA",
    "EL NORTE ESTA CERCA",
    "VUELVE ENTERO",
    "UN PASO MAS",
    "LA SALIDA RESPIRA",
    "TE FALTA CASA",
    "QUE TE VEAN LLEGAR"
  ],

  energyDecay: [
    "TU ENERGIA BAJA",
    "EL AURA SE CIERRA",
    "BUSCA ENERGIA",
    "EL NORTE SE ALEJA",
    "TE FALTA LUZ",
    "LA MARCA SE ENFRIA",
    "NO TE QUEDES ABAJO",
    "TU FUERZA CAE"
  ],

  criticalEnergy: [
    "ENERGIA CRITICA",
    "VAS VACIO",
    "TE ALCANZAN",
    "NO HAY AURA",
    "EL CUERPO CEDE",
    "BUSCA LA MARCA",
    "LA MANADA SE ALEJA",
    "SUBE YA"
  ],

  spiritsClose: [
    "TE OIMOS",
    "CORRES COMO PRESA",
    "NO HAY MANADA AQUI",
    "ESTAS TARDE",
    "NO LLEGAS",
    "TU HUELLA TIEMBLA",
    "EL BOSQUE TE MIDE",
    "SIGUE HUYENDO"
  ],

  hitOrMistake: [
    "PERDISTE LINEA",
    "EL BOSQUE TE TOCO",
    "TU INSTINTO LLEGO TARDE",
    "TE FALTO NORTE",
    "MIRA ARRIBA",
    "RECUPERA CONTROL",
    "NO BAJES",
    "VUELVE A LA RUTA"
  ],

  forbiddenForest: [
    "CRUZASTE EL LIMITE",
    "EL BOSQUE LO SABE",
    "TODO TE MIRA",
    "LAS RUINAS DESPIERTAN",
    "LA TIERRA TE SIENTE",
    "NO ERA TU SENDERO",
    "YA NO HAY REGRESO",
    "LA RUTA ESTA VIVA"
  ],

  packVoice: [
    "TE ESPERAMOS ARRIBA",
    "VEN ENTERO",
    "TU MANADA LLAMA",
    "NO OLVIDES CASA",
    "TE SENTIMOS CERCA",
    "VUELVE",
    "TRAE TU NOMBRE",
    "LLEGA CON LUZ"
  ]
} as const;

export type RunCampeonMicrotextCategory = keyof typeof RUN_CAMPEON_MICROTEXT_BANK;

export const RUN_CAMPEON_MICROTEXT_RULES = {
  maxVisibleAtOnce: 1,
  minSecondsBetweenPhrases: 2.4,
  positiveDuration: 1.0,
  negativeDuration: 0.75,
  cruelDuration: 0.65,
  finalDuration: 1.15,
  noRepeatPerRun: true,
  criticalEnergyThreshold: 0.22,
  lowEnergyThreshold: 0.34,
  spiritsCloseThreshold: 0.68,
  finalStretchProgress: 0.82
} as const;
